export interface DateCountData {
  date: string;
  count: number;
}

export const fillMissingDates = (data: DateCountData[], startDate: Date, endDate: Date): DateCountData[] => {
  const filledData: DateCountData[] = [];

  for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
    const formattedDate = date.toISOString().split('T')[0];
    const existing = data.find((entry) => entry.date === formattedDate);
    filledData.push({ date: formattedDate, count: existing ? existing.count : 0 });
  }

  return filledData;
};
